import qs from 'qs'
import { authStore } from '~/store/auth' // import the auth store we just created
import { useGeneralStore } from '~/store/GeneralStore'
import { useToasterStore } from '~/store/ToasterStore'

export const $api = $fetch.create({
  async onRequest({ request, options }) {
    const { contextId } = useGeneralStore()

    // Encode the request URI
    request = encodeURI(request)

    // Set base URL and credentials for the request
    options.baseURL = useRuntimeConfig().public.apiURL
    options.credentials = 'include'
    
    // Set default headers and body for non-file requests
    if (!options.files) {
      options.headers = { 
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      }
      if (options.body) {
        options.body = qs.stringify(options.body)
      }
    }

    // Set default method to POST if not specified
    if (!options.method) {
      options.method = "POST"
    }
    
    // Add context ID to the query parameters
    options.query = options.query || {}
    // eslint-disable-next-line
    options.query.context_id = contextId
    
    // Add authorization header if access token is available
    const accessToken = localStorage.getItem('accessToken')
    if (accessToken) {
      options.headers = {
        ...options.headers,
        Authorization: accessToken,
      }
    }
    
    return { request, options }
  },

  async onResponse({ request, response }) {
    if (response?._data) {
      return response._data
    }
    
    return response
  },
  onResponseError({ request, options, response }) {
    const { toggleDialog, setAuthenticated } = authStore()
    const { toastInfoDanger, toastErrors } = useToasterStore()

    if (response.status === 401) {
    // Safely parse the response data
      let data
      try {
        data = typeof response._data === 'string' ? JSON.parse(response._data) : response._data
      } catch (e) {
        data = { error: 'unknown_error', messages: { error: 'An unknown error occurred.' } }
      }

      // Handle specific error cases
      if (data.error === 'invalid_token') {
        toggleDialog('invalid_token')

        //setAuthenticated(false)
      } else if(data.error === 'no_permission') {
        toastInfoDanger('ajaxfail', data.messages.error)
      } else {
        toastInfoDanger('ajaxfail', data.messages.error)
      }
    } else {
      toastErrors(response)
    }
    
    return Promise.reject(response)
  },
})
